define('adminNotificationPreferenceView',[
    'app',
    'module',
    'backbone',
    'marionette',
    'underscore',
    'template!adminNotificationPreferenceView'
], function(
    App,
    Module,
    Backbone,
    Marionette,
    _,
    Tpl
) {
    'use strict';

    Module.exports = Marionette.LayoutView.extend({
        template: Tpl,
        className: 'admin-notification-preference-view',

        ui: {
            enableNotificationsCheckbox: '#enable-notifications',
            notificationCheckboxes: '.notification-checkbox',
            saveButton: '#save-preferences',
            form: '#notification-preferences-form',
            individualSection: '.notification-types-section'
        },

        events: {
            'change @ui.enableNotificationsCheckbox': 'onToggleNotificationSystem',
            'change @ui.notificationCheckboxes': 'onNotificationToggle',
            'click @ui.saveButton': 'onSavePreferences'
        },

        regions: {
            muteRegion: '.muted-notifications-region'
        },

        onRender: function() {
            // Only load preferences if we don't have data yet
            if (!this.mutedNotifications) {
                this.loadPreferences();
            } else {
                // If we have data, update the form after render
                this.updateFormFromData();
            }
        },

        loadPreferences: function() {
            App.request('notifications:get-preferences').done(_.bind(function(notificationPreferences) {
                //console.log('received notificationPreferences', notificationPreferences);

                this.notificationsEnabled = notificationPreferences.notificationsEnabled;
                // Sort mutedNotifications alphabetically
                this.mutedNotifications = Object.keys(notificationPreferences.mutedNotificationTypes)
                    .sort()
                    .reduce(function (sorted, key) {
                        sorted[key] = notificationPreferences.mutedNotificationTypes[key];
                        return sorted;
                    }, {});

                this.render();
            }, this));
        },

        updateFormFromData: function() {
            // Set the main notification system toggle
            this.ui.enableNotificationsCheckbox.prop('checked', this.notificationsEnabled);

            // Set individual notification checkboxes
            _.each(this.mutedNotifications, _.bind(function(isMuted, notificationType) {
                var checkbox = this.$('#notification-' + notificationType);
                checkbox.prop('checked', !isMuted); // Inverted because mutedNotifications stores muted state
            }, this));

            this.updateFormState();
        },

        onToggleNotificationSystem: function() {
            // Only update the visual state, don't change individual preferences
            this.updateFormState();
        },

        onNotificationToggle: function() {
            // Individual notification toggles don't affect the main system toggle
            // Just ensure the main system is enabled if user is changing individual preferences
            if (!this.ui.enableNotificationsCheckbox.is(':checked')) {
                // Optionally, auto-enable the system when user tries to enable individual notifications
                // this.ui.enableNotificationsCheckbox.prop('checked', true);
                // this.updateFormState();
            }
        },

        updateFormState: function() {
            var systemEnabled = this.ui.enableNotificationsCheckbox.is(':checked');

            // Grey out individual section when system is disabled
            if (systemEnabled) {
                this.ui.individualSection.removeClass('disabled');
                this.ui.notificationCheckboxes.prop('disabled', false);
            } else {
                this.ui.individualSection.addClass('disabled');
                this.ui.notificationCheckboxes.prop('disabled', true);
            }
        },

        onSavePreferences: function() {
            var preferences = this.getFormData();

            this.ui.saveButton.prop('disabled', true).text('Saving...');

            App.request('notifications:save-preferences', preferences)
                .done(_.bind(function() {
                    this.ui.saveButton.prop('disabled', false).text('Save');
                    App.trigger('notification:success', 'Preferences saved successfully');
                }, this))
                .fail(_.bind(function() {
                    this.ui.saveButton.prop('disabled', false).text('Save');
                    App.trigger('notification:error', 'Failed to save preferences');
                }, this));
        },

        getFormData: function() {
            var notificationsEnabled = this.ui.enableNotificationsCheckbox.is(':checked');
            var mutedNotificationTypes = {};

            // Build mutedNotificationTypes object - preserve individual preferences regardless of system state
            _.each(this.mutedNotifications, _.bind(function(value, notificationType) {
                var checkbox = this.$('#notification-' + notificationType);
                mutedNotificationTypes[notificationType] = !checkbox.is(':checked'); // Inverted
            }, this));

            return {
                notificationsEnabled: notificationsEnabled,
                mutedNotificationTypes: mutedNotificationTypes
            };
        },

        templateHelpers: function() {
            return {
                notificationTypes: this.mutedNotifications || {},
                notificationsEnabled: this.notificationsEnabled || false,
                formatNotificationLabel: function(notificationType) {
                    // Not translated but human-readable labels for notification types
                    return notificationType.replace(/_/g, ' ').toLowerCase()
                        .replace(/\b\w/g, function(l) { return l.toUpperCase(); });
                }
            };
        }
    });
});
